<template>
  <div class="indexthumbnail">
    <div class="mini_screen" :style="getMiniScreenStyle()"></div>
    <div @mousedown="handleMove($event)" class="view-zone" :style="getViewZoneStyle()"></div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  /* 缩略图 */
  name: 'IndexThumbNail',

  mounted() {
    this.screen_wrapper_outer_dom = document.getElementById('screen-wrapper-outer');
  },
  computed: {
    ...mapState({
      ProjectInfo: state => state.ProjectInfo,
      ThumbNailData: state => state.ThumbNailData,
    }),
  },
  data() {
    return {
      screen_wrapper_outer_dom: null,
    };
  },
  methods: {
    getViewZoneStyle() {
      let { ViewZoneSize, ScreenWrapperOuterFullSize, ViewZonePos } = this.ThumbNailData;
      let width = Math.round((190 * ViewZoneSize.width) / ScreenWrapperOuterFullSize.width);
      let height = Math.round((110 * ViewZoneSize.height) / ScreenWrapperOuterFullSize.height);

      let left = Math.round(
        (ViewZonePos.left / (ScreenWrapperOuterFullSize.width - ViewZoneSize.width)) *
          188 *
          (1 - ViewZoneSize.width / ScreenWrapperOuterFullSize.width),
      );
      let top = Math.round(
        (ViewZonePos.top / (ScreenWrapperOuterFullSize.height - ViewZoneSize.height)) *
          108 *
          (1 - ViewZoneSize.height / ScreenWrapperOuterFullSize.height),
      );
      // console.log(`width: ${width}, height: ${height}`);
      return {
        width: width + 'px',
        height: height + 'px',
        top: top + 'px',
        left: left + 'px',
      };
    },
    getMiniScreenStyle() {
      let { ScreenWrapperOuterFullSize, ScreenCurrentShowSize } = this.ThumbNailData;
      let width = Math.round((188 * ScreenCurrentShowSize.width) / ScreenWrapperOuterFullSize.width);
      let height = Math.round((108 * ScreenCurrentShowSize.height) / ScreenWrapperOuterFullSize.height);
      return { width: width + 'px', height: height + 'px', top: 2 + 'px', left: 2 + 'px' };
    },
    handleMove(e) {
      let { ViewZoneSize, ScreenWrapperOuterFullSize } = this.ThumbNailData;

      const startY = e.clientY;
      const startX = e.clientX;

      let maxDragTop = Math.round(
        ((ScreenWrapperOuterFullSize.height - ViewZoneSize.height) / ScreenWrapperOuterFullSize.height) * 108,
      );

      let maxDragLeft = Math.round(
        ((ScreenWrapperOuterFullSize.width - ViewZoneSize.width) / ScreenWrapperOuterFullSize.width) * 188,
      );

      const startTop = parseInt(this.getViewZoneStyle().top);
      const startLeft = parseInt(this.getViewZoneStyle().left);

      let move = moveEvent => {
        const currX = moveEvent.clientX;
        const currY = moveEvent.clientY;

        let distanceY = currY - startY;
        let distanceX = currX - startX;

        let moveDistanceBaseTop = startTop + distanceY;
        let moveDistanceBaseLeft = startLeft + distanceX;

        if (moveDistanceBaseTop >= maxDragTop) {
          moveDistanceBaseTop = maxDragTop;
        }

        if (moveDistanceBaseLeft >= maxDragLeft) {
          moveDistanceBaseLeft = maxDragLeft;
        }

        if (moveDistanceBaseTop <= 0) {
          moveDistanceBaseTop = 0;
        }

        if (moveDistanceBaseLeft <= 0) {
          moveDistanceBaseLeft = 0;
        }

        let realMoveTop =
          (moveDistanceBaseTop * (ScreenWrapperOuterFullSize.height - ViewZoneSize.height)) /
          (108 * (1 - ViewZoneSize.height / ScreenWrapperOuterFullSize.height));

        let realMoveLeft =
          (moveDistanceBaseLeft * (ScreenWrapperOuterFullSize.width - ViewZoneSize.width)) /
          (188 * (1 - ViewZoneSize.width / ScreenWrapperOuterFullSize.width));

        if (this.screen_wrapper_outer_dom) {
          this.screen_wrapper_outer_dom.scrollTop = realMoveTop;
          this.screen_wrapper_outer_dom.scrollLeft = realMoveLeft;
        }
      };
      const up = () => {
        document.removeEventListener('mousemove', move);
        document.removeEventListener('mouseup', up);
      };
      document.addEventListener('mousemove', move);
      document.addEventListener('mouseup', up);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.indexthumbnail {
  width: 190px;
  height: 110px;
  overflow: hidden;
  background: #000;

  .mini_screen {
    position: absolute;
    border: 1px solid rgb(19, 255, 255);
    transition: width 0.2s linear;
    transition: height 0.2s linear;
  }
  .view-zone {
    cursor: move;
    position: absolute;
    border: 1px solid rgb(0, 132, 255);
    box-sizing: border-box;
    box-shadow: rgb(0, 0, 0) 0px 0px 30px 0px;
    transition: width 0.2s linear;
    transition: height 0.2s linear;
  }
}
</style>
